import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logos/logo-circle-indigo.svg")